"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var Autosuggest = require("react-autosuggest");
var pp_react_1 = require("@paypalcorp/pp-react");
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var modalHeader_1 = require("../../../actions/modalHeader");
var page = require("page");
/**
 * Set Primary Confirm Component
 */
var StateList = /** @class */ (function (_super) {
    tslib_1.__extends(StateList, _super);
    function StateList(props) {
        var _this = _super.call(this, props) || this;
        // Toggling value of list page visibility in case of mweb
        _this.toggleListPageVisibility = function () {
            var updatedForm = tslib_1.__assign({}, _this.props.updatedForm);
            updatedForm["stateListInvoked"] = false;
            _this.props.updateForm(updatedForm);
            window.history.go(-1);
        };
        // Autosuggest will call this function every time you need to update suggestions.
        // You already implemented this logic above, so just use it.
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value;
            _this.setState({
                suggestions: _this.getSuggestions(value),
            });
        };
        // Teach Autosuggest how to calculate suggestions for any given input value.
        _this.getSuggestions = function (value) {
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            return inputLength === 0
                ? _this.props.stateList
                : _this.props.stateList.filter(function (state) {
                    return state.label.toLowerCase().slice(0, inputLength) ===
                        inputValue;
                });
        };
        // When suggestion is clicked, Autosuggest needs to populate the input
        // based on the clicked suggestion.
        _this.getSuggestionValue = function (suggestion) { return suggestion.label; };
        // render suggestions.
        _this.renderSuggestion = function (suggestion) { return (React.createElement("div", { className: "listItem" },
            React.createElement(pp_react_1.Text, { size: "md" }, suggestion.label))); };
        _this.renderInput = function (inputProps) { return (React.createElement("div", null,
            React.createElement(pp_react_1.TextInput, tslib_1.__assign({ name: "help", value: "", label: "Search State", leftIcon: React.createElement(pp_react_1.Icon, { size: "sm", name: "search" }) }, inputProps)))); };
        // start : SearcBox related functions
        // Called when user types in the text input of list page for searching state name
        _this.onChange = function (event, _a) {
            var newValue = _a.newValue, method = _a.method;
            if (method !== "click") {
                _this.setState({
                    value: newValue,
                });
            }
            else {
                if (method === "click") {
                    _this.passValueToDropdown(newValue);
                }
            }
        };
        /* passing selected value from list page to the dropdown*/
        _this.passValueToDropdown = function (newValue) {
            var selectedState = _this.props.stateList.find(function (state) { return state.label === newValue; });
            var updatedForm = tslib_1.__assign({}, _this.props.updatedForm);
            var updatedFormElement = tslib_1.__assign({}, updatedForm["state"]);
            updatedFormElement.value = selectedState.id;
            updatedFormElement.isValid = true;
            updatedForm["state"] = updatedFormElement;
            updatedForm["stateListInvoked"] = false;
            // update the chosen state on the edit and address page
            _this.setState({
                form: updatedForm,
                formIsValid: true,
                openListPage: false,
                value: selectedState.id,
                label: selectedState.label,
            });
            _this.props.updateForm(updatedForm);
            window.history.go(-1);
            return false;
        };
        var properties = _this.props.addressData.newAddress.entryMetadata
            .properties;
        var stateList = properties && properties.state ? properties.state.list : [];
        _this.state = {
            suggestions: stateList,
            value: "",
            label: "",
            openListPage: false,
            innerWidth: window.innerWidth,
            formIsValid: false,
            errorMessage: "",
            formSubmitted: false,
            showSpinner: false,
            form: _this.props.updatedForm,
            addressUpdateId: _this.props.route.enter.params.id,
            isNavigationChanged: false,
        };
        return _this;
    }
    StateList.prototype.componentDidMount = function () {
        if (this.props.showNavigation) {
            this.props.changeHeaderVisibility(false);
            this.setState({ isNavigationChanged: true });
        }
        window.scroll({ top: 0, behavior: "smooth" });
    };
    StateList.prototype.componentWillUnmount = function () {
        if (this.state.isNavigationChanged) {
            this.props.changeHeaderVisibility(true);
        }
    };
    /* Container to display sugestions */
    StateList.prototype.renderSuggestionsContainer = function (_a) {
        var containerProps = _a.containerProps, children = _a.children;
        return (React.createElement("div", null,
            React.createElement("div", { className: "listPage-divider" },
                React.createElement(pp_react_1.Divider, null)),
            React.createElement("div", { className: "suggestionContainer-body" },
                React.createElement("div", tslib_1.__assign({}, containerProps), children))));
    };
    StateList.prototype.showClose = function (flag) {
        if (flag) {
            return (React.createElement("div", { onClick: this.toggleListPageVisibility },
                React.createElement(pp_react_1.Icon, { size: "sm", name: "close" })));
        }
    };
    StateList.prototype.shouldRenderSuggestions = function (value) {
        return value.trim().length > -1;
    };
    StateList.prototype.render = function () {
        var _a = this.state, value = _a.value, suggestions = _a.suggestions, inputProps = {
            value: value,
            type: "search",
            onChange: this.onChange,
            passValueToDropdown: this.passValueToDropdown,
        };
        var closeFlag;
        if (commonweb_utils_1.objectUtils.safeGet(this.props.deviceInfo, "deviceType") === "WEBVIEW") {
            closeFlag = false;
        }
        else {
            closeFlag = true;
        }
        var listPage = (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("table", { className: "listPageInput" },
                    React.createElement("tr", null,
                        React.createElement("td", { className: "listPageInput_space_left" }),
                        React.createElement("td", { className: "listPageInput_space_centre" },
                            React.createElement("div", null,
                                React.createElement(pp_react_1.Text, { size: "md", medium: true }, this.props.addressContent.select.state))),
                        React.createElement("td", { className: "listPageInput_space_right" }, this.showClose(closeFlag))))),
            React.createElement(Autosuggest, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, getSuggestionValue: this.getSuggestionValue, renderSuggestion: this.renderSuggestion, focusInputOnSuggestionClick: false, inputProps: inputProps, renderSuggestionsContainer: this.renderSuggestionsContainer, shouldRenderSuggestions: this.shouldRenderSuggestions, alwaysRenderSuggestions: true, renderInputComponent: this.renderInput })));
        return React.createElement("div", { className: "generic-container fullHeight" }, listPage);
    };
    return StateList;
}(React.Component));
var mapStateToProps = function (_a, ownProps) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti, deviceInfo = _a.deviceInfo;
    var addressData = account.addressData, addressFpti = fpti.address, properties = commonweb_utils_1.objectUtils.safeGet(addressData, "newAddress.entryMetadata.properties"), stateList = properties && properties.state ? properties.state.list : [], addressContent = content.addresses, commonContent = content.common, showNavigation = account.showNavigation, addContext = ownProps && ownProps.addContext, updatedForm = account.addressData.updatedForm;
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        addressData: addressData,
        addressContent: addressContent,
        commonContent: commonContent,
        links: links,
        addressFpti: addressFpti,
        stateList: stateList,
        showNavigation: showNavigation,
        deviceInfo: deviceInfo,
        addContext: addContext,
        updatedForm: updatedForm,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchAddAddress: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        addAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        updateForm: function (value) { return dispatch(addresses_1.updateForm(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(StateList);
